var helper = require('../../helper');
require('moment');
require('jquery-ui');
require('jquery-ui/ui/widgets/draggable');

console.log('ticketCalendarOfMemberController');

var TicketCalendarOfMemberController = function(datatable) {

    this.datatable = datatable;
    this.userId = $('#js-user-id').data('user');
    this.calendar = $('#tickets-calendar-member');
    this.$modal = $('#modal-ticket-from-calendar');
    this.$updateButton = this.$modal.find('.modal-submit-button');
    this.$deleteButton = this.$modal.find('.js-modal-delete-button');
    this.$goToUserCalendar = $('.js-ticket-go-to-user-calendar');
    this.$unassignedTickets = $('div.event-in-filter');
    this.filterContactSelect = $('#calendar_member_filter_contact_select');

    this.EditModalFormController = new (require('../../services/modals/ModalFormController'))(this.$modal);
    this.TicketCalendarController = new (require('../../modules/tickets/TicketCalendarController'))();
    this.ToastrController = new (require('../../services/ToastrController'));

    var self = this; // Needed for using all constructor variables inside this function, note the difference -> no "this" but "var" at the beginning

    (function()
    {

        self.$updateButton.click(function(e){
            self.updateModel(e);
        });

        self.$deleteButton.click(function(e){
            self.deleteModel(this, e);
        });

	    self.filterContactSelect.change(function(e){
		    self.filterUnassignedTicketByContact(this, e);
	    });

	    self.generateDraggableTickets();

    }());


}

TicketCalendarOfMemberController.prototype.render = function(message, title) {

    var self = this;

    this.calendar.fullCalendar('destroy');

    this.calendar.fullCalendar({
        events: helper.getOrigin() + "/api/tickets/member/" + this.userId,
        header: {
            left: '',
            center: 'prev title next',
            right: 'listWeek,month,agendaWeek,agendaDay'
        },
        defaultView: 'listWeek',
	    timeFormat: 'HH:mm',
	    minTime: '06:00',
        firstDay: 1,
        editable: true,
        droppable: true,
        dropAccept: 'div.event-in-filter',

	    eventRender: function(event, element) {
		    self.TicketCalendarController.renderEventWithContractorInformation(event, element);
	    },

	    eventClick: function (event) {

            var  fieldsInput = ['id', 'assigned', 'equipment_purchased'],
		         fieldsText = ['contractor_user', 'contractor_decision', 'calendar_description', 'ticket_status', 'title'];

            self.getModel(event.id, function(data){
	            self.EditModalFormController.loadTicketData(data, fieldsInput, fieldsText);
                self.EditModalFormController.showModal(); // on CALLBACK!
            });

        },

	    drop: function (date) {

		    // retrieve the dropped element's stored Event Object
		    var originalEventObject = $(this).data('eventObject');

		    // we need to copy it, so that multiple events don't have a reference to the same object
		    var copiedEventObject = $.extend({}, originalEventObject);
		    copiedEventObject.start = date.format("DD/MM/YYYY HH:mm");
		    copiedEventObject.end = date.format("DD/MM/YYYY HH:mm");
		    copiedEventObject.id = $(this).data('id');

		    /** Add event when dropped */
		    $.ajax({
			    url: '/api/tickets/unassigned/add',
			    data: {
				    title: copiedEventObject.title,
				    start: copiedEventObject.start,
				    end: copiedEventObject.end,
				    id: copiedEventObject.id
			    },
			    type: 'POST',
			    dataType: 'json',
			    success: function (response) {
				    var ticket = response.ticket;
				    self.calendar.fullCalendar('renderEvent', ticket, true);
				    $('#unassigned-ticket-'+ticket.id).remove();
				    console.log('Successfully added an unassigned ticket!');
			    },
			    error: function (e) {
				    console.log('Error' + e);
			    }
		    });
	    },

	    eventDragStop: function (event, jsEvent) {

		    var trashEl = $('#calendarTrash');
		    var ofs = trashEl.offset();

		    var x1 = ofs.left;
		    var x2 = ofs.left + trashEl.outerWidth(true);
		    var y1 = ofs.top;
		    var y2 = ofs.top + trashEl.outerHeight(true);

		    if (jsEvent.pageX >= x1 && jsEvent.pageX <= x2 &&
				    jsEvent.pageY >= y1 && jsEvent.pageY <= y2) {

			    /** Destroy event when dropped onto thrash icon */
			    $.ajax({
				    url: '/api/tickets/calendar/ticket/destroy',
				    data: {
					    id: event.id
				    },
				    type: 'POST',
				    dataType: 'json',
				    success: function (response) {
					    if (response.status == 'success'){
						    self.calendar.fullCalendar('removeEvents', event.id);

						    var $locationWrapper = $('.event-in-filter-in-group[data-location="'+event.location_id+'"]'),
								    ticket = '<div class="event-in-filter ui-draggable ui-draggable-handle" id="unassigned-ticket-'+event.id+'" ' +
										    'data-id="'+event.id+'" data-contact-id="'+event.contractor_contact_id+'" style="background-color:'+event.color+'">' +
										    event.id+' - '+event.title_unassigned+'</div>',
								    filteredContactId = self.filterContactSelect.val();

						    $locationWrapper.append(ticket);

						    var $newTicket = $('#unassigned-ticket-'+event.id);

						    if(!event.contractor_contact_id &&  filteredContactId > 0){ // ticket does not assigned to contact

							    if(filteredContactId < 1){ // if show all or unassigned
								    $newTicket.show();
							    } else{
								    $newTicket.hide();
							    }

						    } else{

							    if(filteredContactId == 0){ // show all
								    $newTicket.show();
							    } else if(event.contractor_contact_id == filteredContactId){ // show tickets of contact of ticket
								    $newTicket.show();
							    } else{
								    $newTicket.hide();
							    }

						    }

						    self.generateDraggableTickets();

					    } else {
						    console.log('An error has occurred while trying to delete a ticket.');
					    }
				    },
				    error: function (e) {
					    console.log('Error' + e);
				    }
			    });
		    }

	    },

	    eventDrop: function (event, jsEvent, ui, view) {
		    self.changeBookInDates(event);
	    },

	    eventResize: function (event, jsEvent, ui, view) {
		   self.changeBookInDates(event);
	    },

    });

    self.datatable.reload();

	self.$goToUserCalendar.on('change', function(e) {
		var userId = $(this).val();

		if(userId > 0){
			window.location.href = helper.getOrigin() + "/tickets/member/" + userId;
		}
	});
}

TicketCalendarOfMemberController.prototype.changeBookInDates = function(event) {
	this.TicketCalendarController.changeBookInDates(event, this.calendar);
}

TicketCalendarOfMemberController.prototype.generateDraggableTickets = function() {
	this.TicketCalendarController.generateDraggableTickets();
}

TicketCalendarOfMemberController.prototype.deleteModel = function(deleteButton, e) {

    var msg = 'Are you sure you want to delete this?';

    if (!confirm(msg)) {
        e.preventDefault();
        return;
    }

    e.preventDefault();

	var ticketId = $(deleteButton).data('ticket')

    this.TicketCalendarController.deleteModel(this, this.EditModalFormController, ticketId);
}

TicketCalendarOfMemberController.prototype.filterUnassignedTicketByContact = function(filterContactSelect, e) {
	this.TicketCalendarController.filterUnassignedTicketByContact(filterContactSelect);
}

TicketCalendarOfMemberController.prototype.updateModel = function(e) {
    e.preventDefault();
    this.TicketCalendarController.updateModel(this, this.EditModalFormController);
}

TicketCalendarOfMemberController.prototype.getModel = function(modelId, callbackSuccess) {
    return this.TicketCalendarController.getModel(modelId, callbackSuccess);
}

TicketCalendarOfMemberController.prototype.getFormData = function(unindexed_array) {
    return this.TicketCalendarController.getFormData(unindexed_array);
}

TicketCalendarOfMemberController.prototype.clearModal = function() {
    this.EditModalFormController.clearModal();
}

TicketCalendarOfMemberController.prototype.showModal = function() {
    this.EditModalFormController.showModal();
}

TicketCalendarOfMemberController.prototype.closeModal = function() {
    this.EditModalFormController.closeModal();
}

module.exports = TicketCalendarOfMemberController;
